module.exports = "table {\n  white-space: nowrap; }\n\n.table-div {\n  max-width: 100%;\n  overflow: auto; }\n\nlabel {\n  display: block;\n  text-align: center; }\n\n.coreAction {\n  width: 100%; }\n\n.action {\n  width: 13%; }\n\n.actionsSection {\n  background-color: #fffffffd;\n  -webkit-transition: 0.3s;\n  transition: 0.3s; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-billing-list.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-billing-list/bc-billing-list.component.scss
// module chunks = main